export enum Alignment {
  Center = 'center',
  Left = 'left',
}

export enum HTag {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
}

export interface IHeadline {
  headlineAlignment?: Alignment;
  hTag: HTag;
  id?: string;
  title: string;
}
